/**************
Global
***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price ($51.27 = 5127)
function price(amount) {
    return `$${Math.round(parseFloat(amount)/100)}`;
}

//image resizer
function imageResizer(url, size) {
    let lastPeriod = url.lastIndexOf(".");
    return `${url.substring(0, lastPeriod)}_${size}${url.substring(lastPeriod)}`;
}


/********
Collection Item
*********/
function appendProduct(selector, product) {
    function productPrice() {
        if (product.price < product.compare_at_price) {
            return `
                <span class="sale">${price(product.price)}</span>
                <span>${price(product.compare_at_price)}</span>
            `;
        }

        return `<span>${price(product.price)}</span>`;
    }

    function productBanner() {
        if (product.available == false) {
            return `<div class="collectionItemBanner soldOut">Sold Out</div>`;
        } else if (product.price < product.compare_at_price) {
            return `<div class="collectionItemBanner sale">Sale</div>`;
        }
        return "";
    }

    document.querySelector(selector).insertAdjacentHTML("beforeend", `
        <a class="collectionItem" href="${product.url}">
            <img class="collectionImage ${product.available ? "" : "soldOut"}" src="${imageResizer(product.featured_image, "large")}">
            <div class="collectionItemRow">
                <div class="collectionItemTitle">${product.title}</div>
                <div class="collectionItemPrice">
                    ${productPrice()} 
                </div>
            </div>

            ${productBanner()}
        </a>
    `);
}